import { render, staticRenderFns } from "./SVGLoader.vue?vue&type=template&id=5a8d379a&scoped=true"
import script from "./SVGLoader.vue?vue&type=script&lang=js"
export * from "./SVGLoader.vue?vue&type=script&lang=js"
import style0 from "./SVGLoader.vue?vue&type=style&index=0&id=5a8d379a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d379a",
  null
  
)

export default component.exports